import { Step } from "./Step";
import { EVENTS } from "../Constants";

export class Financing extends Step {
    constructor(formWrapper: HTMLFormElement) {
        super("vehicle-request-financing", EVENTS.FINANCING, formWrapper);
    }

    protected initTabs(): this {
        super.initTabs();
        this.tabs.dataset.active = "financing";
        return this;
    }
}
